import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";

const descCols = [
  {
    heading: "5,000+",
    desc: "Students empowered with AI-driven academic support and performance tracking",
  },
  {
    heading: "Unified Platform",
    desc: "Complete school management and parent engagement in a seamless SaaS + mobile ecosystem",
  },
  {
    heading: "95%",
    desc: "Parent engagement powered by real-time updates and live transport visibility",
  },
  {
    heading: "70%",
    desc: "Administrative workload reduced through automation and intelligent workflows",
  },
];

const DesSec = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 10 },
        backgroundColor: "#0f172a",
        color: "#ffffff",
      }}
    >
      {/* 👇 Wider container */}
      <Container maxWidth="xl">
        {/* Header */}
        <Box textAlign="center" mb={{ xs: 6, md: 8 }}>
          <Typography variant="h3" fontWeight={800} sx={{ mb: 2 }}>
            Impact Powered by Intelligence
          </Typography>

          <Typography
            variant="h6"
            sx={{
              maxWidth: 850,
              mx: "auto",
              opacity: 0.85,
              lineHeight: 1.8,
            }}
          >
            MySchoolling combines AI, automation, and real-time engagement
            to deliver measurable outcomes across schools and families.
          </Typography>
        </Box>

        {/* 👇 Better grid sizing */}
        <Grid container spacing={5} justifyContent="center">
          {descCols.map((item, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}      // 👈 3 per row on medium
              lg={3}      // 👈 4 per row on large screens
              key={index}
            >
              <Box
                sx={{
                  p: { xs: 4, md: 5 },
                  borderRadius: 4,
                  background: "rgba(255,255,255,0.05)",
                  border: "1px solid rgba(255,255,255,0.08)",
                  backdropFilter: "blur(8px)",
                  textAlign: "center",
                  height: "100%",
                  transition: "all 0.35s ease",

                  "&:hover": {
                    transform: "translateY(-8px)",
                    background: "rgba(255,255,255,0.08)",
                    boxShadow:
                      "0 25px 70px rgba(66,165,245,0.25)",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "2rem", md: "2.4rem" },  // 👈 slightly reduced
                    fontWeight: 900,
                    mb: 2,
                    lineHeight: 1.2,
                    wordBreak: "normal",       // 👈 prevent weird split
                    whiteSpace: "normal",
                    background:
                      "linear-gradient(135deg, #42a5f5 0%, #1976d2 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  {item.heading}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    opacity: 0.85,
                    lineHeight: 1.8,
                  }}
                >
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default DesSec;